




























































import { defineComponent, reactive, toRefs, onMounted, onBeforeUnmount } from '@vue/composition-api';
import Axios from 'axios';
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { MovieContent } from "../../modules/teacher/MovieContentUpload"

export interface Data {
  tabNo: number,
  base_sheet_id: string,
  baseSheet: any,
  movieContents: MovieContent[],
  errors: any[],
}

interface DownloadMovieResponse {
  download_url: string,
  expires_in: number,
}

interface UploadResponse {
  upload_url: string,
  temp_s3_key: string,
  expires_in: number,
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      tabNo: 8,
      base_sheet_id: "",
      baseSheet: null,
      movieContents: [],
      errors: [],
    });

    /******************************
     * methods
     ******************************/

    /**
     * 動画アップロード処理
     */

    const upload = async (files: any) => {
      if(state.errors.length > 0){
        return;
      }
      if(!files || files.length == 0){
        state.errors = ["アップロード対象のファイルが取得できませんでした。"];
        return;
      }

      if(!window.confirm("ファイルをアップロードします。\n実行してよろしいですか？")){
        return;
      }

      const file = files[0];
      let uploadUrl = "";
      let tempS3Key = "";

      context.root.$store.dispatch("showOverlay", {
        overlayText: "ファイル送信中。画面を閉じずにお待ちください。",
        isShowProgress: true,
      });
      context.root.$store.commit("setProgressText", 0);
      state.errors = [];

      await http.post(`/api/teacher/movie_content_upload/issue_upload_url/${state.base_sheet_id}`, {original_filename: file.name}).then(response => {
        const data = response.data as UploadResponse;
        uploadUrl = data.upload_url;
        tempS3Key = data.temp_s3_key;
        state.errors = [];
      })
      .catch(error=>{
        if(error.response && error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      if(state.errors.length > 0){
        context.root.$store.dispatch("hideOverlay");
        return;
      }

      context.root.$store.commit("setProgressText", 20);
      await Axios.put(uploadUrl, file, {
        headers: {
          "Content-Type": "video/mp4",
        },
      })
      .catch(error=>{
        if(error.response && error.response.status){
          state.errors = ["動画ファイルのアップロードに失敗しました。"];
        }else{
          state.errors = ["動画ファイルのアップロードに失敗しました。"];
        }
      });

      if(state.errors.length > 0){
        context.root.$store.dispatch("hideOverlay");
        return;
      }

      context.root.$store.commit("setProgressText", 70);
      await http.post(`/api/teacher/movie_content_upload/complete_upload/${state.base_sheet_id}`, {
        original_filename: file.name,
        temp_s3_key: tempS3Key,
      }).then(async response => {
        state.movieContents = response.data.movie_contents as MovieContent[];
        state.errors = [];
        context.root.$store.commit("setProgressText", 100);
        await resolveAfterMilliSeconds();
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response && error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      if(state.errors.length == 0){
        context.root.$store.commit("setProgressText", 100);
      }
      context.root.$store.dispatch("hideOverlay");
    };

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 600);
      });
    }

    /**
     * 動画ダウンロード処理
     */
    const downloadMovie = async (movieContent: MovieContent) => {
      context.root.$store.dispatch("showOverlay", "動画ダウンロード中");
      await http.get(`/api/teacher/movie_content_upload/download/${movieContent.id}`).then(response => {
        const data = response.data as DownloadMovieResponse;
        const a = document.createElement("a");
        a.href = data.download_url;
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        a.remove();
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /**
     * 動画削除処理
     */
    const destroyMovie = async (movieContent: MovieContent) => {
      if(!window.confirm(`ID:${movieContent.id} の動画を削除します。\n実行してよろしいですか？`)){
        return;
      }

      context.root.$store.dispatch("showOverlay", "削除処理中");
      await http.post(`/api/teacher/movie_content_upload/destroy/${state.base_sheet_id}`, {movie_content_id: movieContent.id}).then(response => {
        state.movieContents = response.data.movie_contents as MovieContent[];
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /**
     * 動画並び順更新処理
     */
    const updateSort = async () => {
      const movieContentIds = state.movieContents.map((x: MovieContent) => x.id);
      await http.post(`/api/teacher/movie_content_upload/update_sort/${state.base_sheet_id}`, {movie_content_ids: movieContentIds}).then(response => {
        state.movieContents = response.data.movie_contents as MovieContent[];
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /**
     * 動画上移動処理
     */
    const moveUp = async (idx: number) => {
      if(idx <= 0){
        return;
      }
      const temp = state.movieContents[idx - 1];
      state.movieContents[idx - 1] = state.movieContents[idx];
      state.movieContents[idx] = temp;
      await updateSort();
    };

    /**
     * 動画下移動処理
     */
    const moveDown = async (idx: number) => {
      if(idx >= state.movieContents.length - 1){
        return;
      }
      const temp = state.movieContents[idx + 1];
      state.movieContents[idx + 1] = state.movieContents[idx];
      state.movieContents[idx] = temp;
      await updateSort();
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;
      await http.get(`/api/teacher/movie_content_upload?base_sheet_id=${state.base_sheet_id}`).then(response => {
        context.root.$store.commit("setScoringSettingSheetType", response.data.base_sheet.sheet_type);
        state.baseSheet = response.data.base_sheet;
        state.movieContents = response.data.movie_contents as MovieContent[];
      })
      .catch(error=>{
        if(error.response && error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      upload,
      downloadMovie,
      destroyMovie,
      moveUp,
      moveDown,
    }
  }
})
